import React from 'react';
import { connect } from 'react-redux';
import Form from 'react-jsonschema-form';
import * as inspectionActions from '../../../inspection/inspection.actions';
import {withStyles} from 'material-ui/styles/index';

const styles = theme => ({
	content: {
		maxWidth: 1040,
		margin: theme.spacing.unit + 'px auto',
		backgroundColor: '#fff',
		paddingLeft: 0,
		paddingRight: 0
	}
});

class SchemaView extends Form {
  render() {
    const { children, safeRenderCompletion, id, name, classes } = this.props;
    const { schema, uiSchema, formData, errorSchema, idSchema } = this.state;
    const registry = this.getRegistry();
    const SchemaField = registry.fields.SchemaField;

    return (
      <div id={id}
           name={name}
           className={classes.content}>
        <SchemaField
          schema={schema}
          uiSchema={uiSchema}
          errorSchema={errorSchema}
          idSchema={idSchema}
          formData={formData}
          readonly={true}
          onChange={this.onChange}
          onBlur={this.onBlur}
          onFocus={this.onFocus}
          registry={registry}
          safeRenderCompletion={safeRenderCompletion}
        />
        {children}
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {};
};


// export default connect(mapStateToProps, Object.assign({}, actions))(
// 	withStyles(styles)(InspectionView)
// );

export default connect(mapStateToProps, inspectionActions)(
  withStyles(styles)(SchemaView)
);



// WEBPACK FOOTER //
// ./src/modules/common/components/form/SchemaView.js